/** @jsxImportSource @emotion/react */
import React from 'react'

const StatementPaymentSuccess: React.FC = () => {
  return (
    <div className="container py-5" css={{ maxWidth: 720, textAlign: 'center' }}>
      <div className="d-flex align-items-center justify-content-center mb-3">
        <i className="fa fa-check text-success mr-3" css={{ fontSize: 30 }} />
        <h2>Thank you!</h2>
      </div>
      <p css={{ fontSize: 18 }}>
        Your payment has been processed successfully.
      </p>
      <button className="btn btn-primary" onClick={() => window.close()}>Close</button>
    </div>
  )
}

export default StatementPaymentSuccess
